import {fileResourceAxios} from "lib/http/http.common"
import {ImageFile} from "dto/file-resource/file-resource"

export const findImageResourceById = (id: string) => {
    return fileResourceAxios.get<ImageFile>(`/${id}`)
}

export const ImageResourceApi = {
    findImageResourceById
}
